import { Routes } from '@angular/router';
import { ContentComponent } from './shared/components/layout/content/content.component';
import { content } from './shared/routes/routes';
import { LoginComponent } from './features/auth/login/login.component';
import { RegisterComponent } from './features/auth/register/register.component';
import {AuthGuard} from "./core/guards/auth.guard";
import {UnauthorizedComponent} from "./features/auth/unauthorized/unauthorized.component";

export const routes: Routes = [
  { path: 'login', loadChildren: () => import('./features/auth/auth.module').then(m => m.AuthModule) },
  {
    path: '',
    component: ContentComponent,
    children: content,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard]
  },
  { path: '**', redirectTo: 'login' }
];

/*
src/
├── app/
│   ├── core/                # Contiene servicios y lógica central de la aplicación
│   │   ├── guards/          # Guards para rutas
│   │   ├── interceptors/    # Interceptores HTTP
│   │   ├── services/        # Servicios comunes (auth, permisos)
│   │   └── models/          # Modelos y tipados compartidos
│   ├── shared/              # Componentes reutilizables
│   │   ├── components/      # Botones, inputs, tablas, etc.
│   │   ├── directives/      # Directivas reutilizables
│   │   └── pipes/           # Pipes reutilizables
│   ├── features/            # Módulos funcionales principales
│   │   ├── auth/            # Módulo de autenticación (login, registro)
│   │   ├── dashboard/       # Módulo principal tras autenticación
│   │   ├── admin/           # Ejemplo de módulo restringido para admins
│   │   └── user/            # Ejemplo de módulo para usuarios
│   ├── app-routing.module.ts # Configuración global de rutas
│   ├── app.component.ts     # Componente principal
│   └── app.module.ts        # Módulo principal
└── assets/                  # Recursos estáticos (imágenes, estilos globales)

*/
